/* tslint:disable */
/* eslint-disable */
/* @relayHash 3ba5a40d7f9a3cb5af9b8552d1335f35 */

import { ConcreteRequest } from "relay-runtime";
export type vipCuratedFolderRule_QueryVariables = {
    userId: string;
};
export type vipCuratedFolderRule_QueryResponse = {
    readonly viewer: {
        readonly isDisabled: boolean | null;
        readonly user: {
            readonly activityFeed: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly status: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    };
};
export type vipCuratedFolderRule_Query = {
    readonly response: vipCuratedFolderRule_QueryResponse;
    readonly variables: vipCuratedFolderRule_QueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "isDisabled",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableCuratedFolders"
    }
  ],
  "storageKey": "isEnabled(key:\"disableCuratedFolders\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "elementTypes",
    "value": [
      "VIP_CURATED_PORTFOLIO_SHARE"
    ]
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "vipCuratedFolderRule_Query",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activityFeed",
                "storageKey": "activityFeed(elementTypes:[\"VIP_CURATED_PORTFOLIO_SHARE\"],first:1)",
                "args": (v3/*: any*/),
                "concreteType": "ActivityFeedConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ActivityFeedEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ActivityFeedElement",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "vipCuratedFolderRule_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "activityFeed",
                "storageKey": "activityFeed(elementTypes:[\"VIP_CURATED_PORTFOLIO_SHARE\"],first:1)",
                "args": (v3/*: any*/),
                "concreteType": "ActivityFeedConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ActivityFeedEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ActivityFeedElement",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "vipCuratedFolderRule_Query",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/vipCuratedFolderRule_Query",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0e669af27fa7965cd38896f52f2d1d7c';
export default node;
